export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a physical product?',
    answer: 'No. CINNAMON ROLL BUSINESS™ is a 100% digital educational system.',
  },
  {
    question: 'Do I need professional baking experience?',
    answer:
      'No. The process is structured step by step so you can understand the complete cinnamon roll production process, including the visual and practical signals you should look for.',
  },
  {
    question: 'Is this just a recipe book?',
    answer:
      "No. Recipes are only part of the system. You'll learn ingredients, dough preparation, fermentation, fillings, shaping, baking, flavors, frostings, finishing, batch preparation, storage principles and troubleshooting.",
  },
  {
    question: 'Can I use what I learn to create products to sell?',
    answer:
      'Yes. The system is designed to help you develop cinnamon rolls that you can potentially offer through your own food business. You remain responsible for complying with the food preparation, licensing, labeling, allergen and sales requirements that apply where you operate.',
  },
  {
    question: "Does the system guarantee that I'll make money?",
    answer:
      'No legitimate business system can guarantee income. Your results depend on factors including execution, product quality, market, pricing, demand and how you operate your business. CINNAMON ROLL BUSINESS™ gives you the product-creation system so you can build a genuine product to sell.',
  },
  {
    question: 'Can I create different flavors?',
    answer:
      'Yes. The system and included flavor bonus provide multiple formulas and a framework for developing additional variations.',
  },
  {
    question: 'Can I prepare more than one batch?',
    answer:
      'Yes. The Batch Production & Prep System teaches you how to organize and scale production according to your actual equipment and capacity.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive digital access immediately after purchase.",
  },
  {
    question: 'Do I need special equipment or a commercial oven?',
    answer:
      'No. The system is built around a normal home kitchen — a standard oven, basic trays and everyday tools. The batch production resources then show you how to scale within the equipment and capacity you already have.',
  },
  {
    question: 'How long do I have access, and what if I need help?',
    answer:
      'You get immediate digital access to the complete system and all five bonuses, and you can return to any module whenever you need it. If you have a question about your access, contact support at kitonline27@gmail.com.',
  },
]
